import { render, staticRenderFns } from "./actionHistory.vue?vue&type=template&id=99828f28&scoped=true&lang=pug&"
import script from "./actionHistory.vue?vue&type=script&lang=ts&"
export * from "./actionHistory.vue?vue&type=script&lang=ts&"
import style0 from "./actionHistory.vue?vue&type=style&index=0&id=99828f28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99828f28",
  null
  
)

export default component.exports